import {Component, EventEmitter, Input, OnInit, Output, ViewEncapsulation} from '@angular/core';
import {AuthService} from '../../../shared/services/auth.service';
import {User} from '../../../shared/models/user.model';
import {UsersService} from '../../users/users.service';
import {UtilService} from '../../../shared/services/util.service';
import {ThemeService} from '../../../shared/services/theme.service';
import {PortfolioModel} from '../../../shared/models/portfolio.model';
import {PortfolioService} from '../../portfolio/portfolio.service';
import {Router} from '@angular/router';
import { MaterialModule } from "src/app/app.materials";
import { RouterModule } from '@angular/router';
import { FormsModule } from '@angular/forms';
import { CommonModule } from '@angular/common';

@Component({
  selector: 'app-nav',
  templateUrl: './nav.component.html',
  styleUrls: ['./nav.component.scss'],
  encapsulation: ViewEncapsulation.None,
  imports: [MaterialModule, RouterModule, CommonModule],
  standalone: true,
})
export class NavComponent implements OnInit {

  @Output() public sidenavToggle = new EventEmitter();

  @Input() portfolio = new PortfolioModel({});

  darkMode = false;

  isSuperAdmin = false;
  isAdmin = false;
  hasCustomAccess = false;
  user: User;
  notifications: any[] = [];

  constructor(
    private authService: AuthService,
    private service: UsersService,
    private util: UtilService,
    private theme: ThemeService,
    private router: Router,
    private portfolioService: PortfolioService
  ) { }

  ngOnInit() {
    // this.portfolioService.portfolio$.subscribe(res => this.portfolio = res);
    // this.fetchNotifications();
    this.authService.getCurrentUser().subscribe(resp => {
      this.user = resp;
      this.hasCustomAccess = this.user.hasCustomAccess();
      this.isSuperAdmin = this.user.isSuperAdmin();
      this.isAdmin = this.user.isSuperAdmin() || this.user.isAdmin();
    });
  }

  fetchNotifications() {
    this.service.getNotifications().subscribe((resp: any) => {
      if (resp.error) {
        return this.service.notificationService.open(resp.error);
      }
      if (resp.length) {
        this.notifications = resp.map(r => {
          r.link = ['/app'];
          r.content = `${r.title}: ${r.text}`;

          switch (+r.type) {
            case 1: // general
              break;
            case 2: // portfolio
              if (r.connection_id) {
                r.link = ['/app/portfolio-view', r.connection_id];
              }
              break;
            case 3: // index list
              break;
            default:
              console.log('Error: undefined notification type: ', r.type);
          }
          return r;
        });
      }
    });
  }

  markAsRead(item) {
    this.service.markAsRead(item).subscribe((resp: any) => {
      if (resp.success) {
        this.notifications = this.util.findAndReplaceItemInArray(item, this.notifications, true);
      }
    });
  }

  markAllAsRead() {
    this.service.markAllAsRead().subscribe((resp: any) => {
      if (resp.success) {
        this.notifications = [];
      }
    });
  }

  onClosePortfolio() {
    console.log('nav')
    this.portfolioService.clear();
    this.router.navigate(['/app'])
  }

  onLogout() {
    this.authService.logout(true);
  }

  onToggleChange(data) {
    this.darkMode = !this.darkMode;
    this.theme.setTheme('material-dark', this.darkMode);
  }

  public onToggleSidenav = () => {
    this.sidenavToggle.emit();
  }
}
